import Vue from 'vue'
import Router from 'vue-router'
import Restrict from '@/auth/restrict'
import Home from '@/views/Home.vue'
import Manage from '@/views/Manage.vue'
import Welcome from '@/views/Welcome.vue'
import Terms from '@/views/Terms.vue'
import Privacy from '@/views/Privacy.vue'
import Callback from '@/views/Callback.vue'
import Login from '@/views/Login.vue'
import NotFound from '@/views/NotFound.vue'
import NotAuthorized from '@/views/NotAuthorized.vue'
import PostEdit from '@/views/PostEdit.vue'
import PostShow from '@/views/PostShow.vue'
import Account from '@/views/Account.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/manage',
      name: 'manage',
      component: Manage,
      meta: { role: 'staff' }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/post/new',
      name: 'new-post',
      component: PostEdit,
      meta: { role: 'user' }
    },
    {
      path: '/post/:id/edit',
      name: 'edit-post',
      component: PostEdit
    },
    {
      path: '/post/:id/:status?',
      name: 'post',
      props: true,
      component: PostShow
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: { role: 'user' }
    },
    {
      name: 'unauthorized',
      path: '/unauthorized',
      component: NotAuthorized
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach(Restrict)

export default router
